export default __webpack_public_path__ + "static/media/caja.53c31faa.png";